(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_dynamic-entry"] && !Shopify.designMode) return;
  try {
    class DynamicEntry extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.media = this.querySelector('.dynamic-entry-media');
      this.content = this.querySelector('.dynamic-entry-content');
    }
  }

  if (!customElements.get('dynamic-entry')) {
    customElements.define('dynamic-entry', DynamicEntry);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const variantId = event.detail?.resource?.id?.toString();
    if (!variantId) return;

    for (const btn of document.querySelectorAll('wishlist-button[data-morph-ignore]')) {
      btn.dataset.variantId = variantId;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dynamic-entries"] && !Shopify.designMode) return;
  try {
    class DynamicEntries extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.entries = this.querySelectorAll('dynamic-entry');
      this.mediasContainer = this.querySelector('.dynamic-entries-medias');
      this.contentsContainer = this.querySelector('.dynamic-entries-contents');

      this.initEvent();
    }

    initEvent() {
      this.entries?.forEach((entry) => {
        entry.addEventListener('click', this.showEntryContent.bind(this, entry));
      });

      this.showEntryContent(this.entries[0]);
    }

    showEntryContent(entry) {
      this.entries?.forEach((entry) => {
        entry.classList.remove('dynamic-entry--active');
      });
      entry.classList.add('dynamic-entry--active');

      if (entry.media) {
        this.mediasContainer.innerHTML = entry.media.innerHTML;
      } else if (entry.querySelector('.dynamic-entry-media')) {
        this.mediasContainer.innerHTML = entry.querySelector('.dynamic-entry-media').innerHTML;
      } else {
        this.mediasContainer.innerHTML = '';
      }

      if (entry.content) {
        this.contentsContainer.innerHTML = entry.content.innerHTML;
      } else if (entry.querySelector('.dynamic-entry-content')) {
        this.contentsContainer.innerHTML = entry.querySelector('.dynamic-entry-content').innerHTML;
      } else {
        this.contentsContainer.innerHTML = '';
      }
    }
  }

  if (!customElements.get('dynamic-entries')) {
    customElements.define('dynamic-entries', DynamicEntries);
  }
  } catch(e) { console.error(e); }
})();

})();
